module.exports = __webpack_public_path__ + "static/media/profile-2-hover.4be300b2.png";